import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 1rem;
`;

export const Content = styled.div`
  padding: 1.5rem;
`;
